import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-6xl" }
const _hoisted_3 = { class: "flex flex-col md:flex-row md:items-center md:justify-between mb-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading text-primary-800 mb-2" }, " Neighborhood Marketplace "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500" }, " Items for sale and free stuff from your neighbors ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" List an Item ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "w-full max-w-2xl max-h-[90vh] overflow-y-auto" }
const _hoisted_9 = { class: "flex flex-wrap gap-2 mb-6" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 1,
  class: "text-center py-16 bg-white rounded-xl border border-primary-200 shadow-soft"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-16 h-16 mx-auto text-primary-300 mb-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-heading font-semibold text-primary-700 mb-2" }, " No items listed yet ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-500 mb-6" }, " Be the first to list something for your neighbors! ", -1)
const _hoisted_15 = {
  key: 2,
  class: "grid gap-6 sm:grid-cols-2 lg:grid-cols-3"
}

import { ref, computed, onMounted } from "vue";
import { usePostStore } from "@/stores/posts";
import CreatePostForm from "@/components/posts/CreatePostForm.vue";
import MarketplaceCard from "@/components/marketplace/MarketplaceCard.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const postStore = usePostStore();

const showCreateForm = ref(false);
const activeFilter = ref("all");

const filters = [
  { label: "All Items", value: "all" },
  { label: "For Sale", value: "for_sale" },
  { label: "Free", value: "free" },
];

const marketplaceItems = computed(() => {
  return postStore.posts.filter(
    (post) => post.type === "for_sale" || post.type === "free"
  );
});

const filteredItems = computed(() => {
  if (activeFilter.value === "all") {
    return marketplaceItems.value;
  }
  return marketplaceItems.value.filter((p) => p.type === activeFilter.value);
});

const handlePostCreated = () => {
  showCreateForm.value = false;
  postStore.get_posts();
};

onMounted(() => {
  postStore.get_posts();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showCreateForm.value = true)),
          class: "mt-4 md:mt-0 inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors shadow-soft"
        }, _hoisted_7)
      ]),
      (showCreateForm.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showCreateForm.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(CreatePostForm, {
                onClose: _cache[1] || (_cache[1] = ($event: any) => (showCreateForm.value = false)),
                onPostCreated: handlePostCreated
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filters, (filter) => {
          return _createElementVNode("button", {
            key: filter.value,
            onClick: ($event: any) => (activeFilter.value = filter.value),
            class: _normalizeClass(["px-4 py-2 text-sm font-medium rounded-full transition-colors", 
            activeFilter.value === filter.value
              ? 'bg-primary-800 text-white'
              : 'bg-white text-primary-600 hover:bg-primary-100 border border-primary-200'
          ])
          }, _toDisplayString(filter.label), 11, _hoisted_10)
        }), 64))
      ]),
      (_unref(filteredItems).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showCreateForm.value = true)),
              class: "inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 transition-colors"
            }, " List an Item ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredItems), (item) => {
              return (_openBlock(), _createBlock(MarketplaceCard, {
                key: item.id,
                item: item
              }, null, 8, ["item"]))
            }), 128))
          ]))
    ])
  ]))
}
}

})